import script from "./OperationGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./OperationGuide.vue?vue&type=script&setup=true&lang=js"

import "./OperationGuide.vue?vue&type=style&index=0&id=078f19aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-078f19aa"]])

export default __exports__